<template>
  <button
    type="button"
    class="mx-auto flex cursor-pointer flex-col items-center gap-1 p-2 text-brand font-bold uppercase tracking-wider group"
    data-testid="totop"
    @click="performScrollToTop"
  >
    <fa-icon
      :icon="faAngleUp"
      class="size-5 group-hover:animate-bounce"
      aria-hidden="true"
    />
    <span class="underline underline-offset-4">{{
      $t('landingpage/scroll_to_top')
    }}</span>
  </button>
</template>

<script setup lang="ts">
import { faAngleUp } from '@fortawesome/pro-solid-svg-icons';

const { scrollToTop } = useWindowScroll();

const performScrollToTop = (): void => scrollToTop();
</script>
